









import {
    Component,
    Vue
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import DieselLocomotivePanelRow from './DieselLocomotivePanelRow.vue'
import ElectricLocomotivePanelRow from './ElectricLocomotivePanelRow.vue'
import Locomotive from '../models/Locomotives/Locomotive'
import DieselLocomotive from '../models/Locomotives/DieselLocomotive'
import Uuid from '@/services/Uuid'
import LocomotivesModule from '@/store/modules/LocomotivesModule'

@Component({components: {
    DieselLocomotivePanelRow,
    ElectricLocomotivePanelRow
}})
export default class Panel extends Vue {
    private locomotiveModule = getModule(LocomotivesModule, this.$store)

    private get locomotivesData()  {
        return this.locomotiveModule.locomotivesData
    }
}
